import {
  FacilityEntity,
} from './facilityEntity';
import { Address } from './valueObjects/address';
import { ChildId } from './valueObjects/childId';
import { Email } from './valueObjects/email';
import { FacilityId } from './valueObjects/facilityId';
import { FacilityName } from './valueObjects/facilityName';
import { ParentId } from './valueObjects/parentId';
import { PostalCode } from './valueObjects/postalCode';
import { Tel } from './valueObjects/tel';

import type {
  FacilityPropsPub,
  FacilityPropsPvt,
} from './facilityEntity';
import type { EntityDataPubType } from '@/domain/entityBase';
import type { EntityDataPubNotNullType, EntityPubNotNullType } from '@/domain/entityPub';
import type { FacilityJsonPub, FacilityJsonPvt } from '@/types/domain/childApply/entities/facilityEntity';

import { FactoryPub } from '@/domain/factoryPub';

export class FacilityFactory extends FactoryPub<
  FacilityEntity,
  FacilityPropsPvt,
  FacilityJsonPvt,
  FacilityPropsPub,
  FacilityJsonPub
> {
  comparePub = (
    a: EntityDataPubType<FacilityJsonPvt, FacilityJsonPub>,
    b: EntityDataPubType<FacilityJsonPvt, FacilityJsonPub>,
  ) => a.data.facilityId.localeCompare(b.data.facilityId, 'en');

  create(
    props: FacilityPropsPvt,
    propsPub: EntityPubNotNullType<FacilityPropsPub>,
  ): FacilityEntity {
    return new FacilityEntity(props, propsPub);
  }

  createFromEntityDataPub(
    props: EntityDataPubNotNullType<FacilityJsonPvt, FacilityJsonPub>,
  ): FacilityEntity {
    return this.create({
      facilityId: FacilityId.create(props.data.facilityId),
      facilityName: FacilityName.create(props.data.facilityName),
      parentId: ParentId.create(props.data.parentId),
      childId: ChildId.create(props.data.childId),
      postalCode: PostalCode.create(props.data.postalCode),
      address: Address.create(props.data.address),
      email: Email.create(props.data.email),
      tel: Tel.create(props.data.tel),
    }, {
      sendId: props.pub.sendId,
      replyId: props.pub.replyId,
      data: {},
    });
  }
}
